import type { GooglePlugin } from '@shared/analytics/types/google'
import {
  onAuthEvent,
  onLoginEvent,
  removeAuthEvent,
  removeLoginEvent,
} from '@shared/event/events/auth'

const initLoginEvents = (Analytics: GooglePlugin) => {
  const loginToken = onLoginEvent(async ({ customer }) => {
    if (!customer.email) {
      return
    }

    await Analytics.user(customer.email)

    Analytics.event({
      event: 'login',
    })
  })

  const authToken = onAuthEvent(async ({ isLoggedIn, customer }) => {
    if (!isLoggedIn || !customer.email) {
      return
    }

    await Analytics.user(customer.email)
  })

  return () => {
    removeLoginEvent(loginToken)
    removeAuthEvent(authToken)
  }
}

export default initLoginEvents
